export default "__VITE_ASSET__DyE41M3l__"